/* eslint-disable react/prop-types */
import React from 'react'

import { IconProps } from '.'

const Kebab: React.FC<IconProps> = ({ size = 20, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 20 20"
      {...rest}
    >
      <path
        fill="#000"
        fillOpacity="0.54"
        fillRule="evenodd"
        d="M10 6.667c.916 0 1.666-.75 1.666-1.666 0-.917-.75-1.667-1.666-1.667-.917 0-1.667.75-1.667 1.667 0 .916.75 1.666 1.667 1.666zm0 1.667c-.917 0-1.667.75-1.667 1.667 0 .916.75 1.666 1.667 1.666.916 0 1.666-.75 1.666-1.666 0-.917-.75-1.667-1.666-1.667zm-1.667 6.667c0-.917.75-1.667 1.667-1.667.916 0 1.666.75 1.666 1.667 0 .916-.75 1.666-1.666 1.666-.917 0-1.667-.75-1.667-1.666z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export default Kebab
